import React from 'react';

import FiltersContext from './FiltersContext';
import { HierarchyContext, useHierarchy } from './hierarchy';
import { FiltersConfig, FiltersValues } from './useFilters';
import { set } from './utils';

export interface PrimaryFiltersProps {
  onSubmit: (values: FiltersValues) => void;
}

const PrimaryFilters: React.FC<FiltersConfig & PrimaryFiltersProps> = ({
  onSubmit,
  initialValues,
  children,
}) => {
  const { state, register, unregister } = useHierarchy({
    values: initialValues,
  });

  const handleSetFieldValue = (name: string, value: any) => {
    onSubmit(set({ ...initialValues }, name, value));
  };

  return (
    <FiltersContext.Provider
      value={{ values: initialValues, setFieldValue: handleSetFieldValue }}
    >
      <HierarchyContext.Provider value={{ state, register, unregister }}>
        {children}
      </HierarchyContext.Provider>
    </FiltersContext.Provider>
  );
};

export default PrimaryFilters;
